const TOKEN = "TDP35F5D28e23T44Z39O8E5D35Z8R48h38n"; // Replace with your actual token
const API_URL = "https://integrations.thediamondport.com/api/lab-grown-diamonds";

document.addEventListener("DOMContentLoaded", function () {
  document.getElementById("searchDiamonds").addEventListener("click", async function () {
    const shape = document.getElementById("shape").value;
    const color = document.getElementById("color").value;
    const clarity = document.getElementById("clarity").value;
    const carat = document.getElementById("carat").value;

    const formData = new FormData();
    formData.append("shape", shape);
    formData.append("color", color);
    formData.append("clarity", clarity);
    formData.append("carat", carat);
    formData.append("cut", "EX,VG,GD,ID");
    formData.append("polish", "EX");
    formData.append("symmetry", "EX");
    formData.append("fluorescence", "NON");
    formData.append("lab", "IGI");
    formData.append("currency", "USD");
    formData.append("perpage", "50");

    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          Accept: "application/json",
        },
        body: formData,
      });

      const data = await response.json();
      displayDiamonds(data);
    } catch (err) {
      console.error("Error fetching diamonds:", err);
      document.getElementById("diamond-results").innerHTML = "<p style='color:red;'>Failed to load data.</p>";
    }
  });
});

function displayDiamonds(data) {
  const container = document.getElementById("diamond-results");
  if (!Array.isArray(data) || data.length === 0) {
    container.innerHTML = "<p>No diamonds found for the selected filters.</p>";
    return;
  }

  const html = data
    .map((d) => {
      return `
      <div style="border:1px solid #ddd; padding:10px; margin:10px;">
        <p><strong>Stock ID:</strong> ${d.stock_id || "N/A"}</p>
        <p><strong>Shape:</strong> ${d.shape}</p>
        <p><strong>Carat:</strong> ${d.carat}</p>
        <p><strong>Color:</strong> ${d.color}</p>
        <p><strong>Clarity:</strong> ${d.clarity}</p>
        <p><strong>Cut:</strong> ${d.cut}</p>
        <p><strong>Polish:</strong> ${d.polish}</p>
        <p><strong>Symmetry:</strong> ${d.symmetry}</p>
        <p><strong>Price/ct:</strong> $${d.pricepercts || "N/A"}</p>
        <p><strong>Total Price:</strong> $${d.totalprice || "N/A"}</p>
      </div>
    `;
    })
    .join("");

  container.innerHTML = html;
}
